export default {"src":"/_next/static/media/process_icon_4.0d37c1cf.svg","height":69,"width":69};